import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, fromEvent, interval, Subscription } from 'rxjs';

const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  private subscriptions: Subscription[] = [];
  private updating = false;

  constructor(private swUpdate: SwUpdate) {}

  checkForUpdates() {
    if (!this.swUpdate.isEnabled || this.subscriptions.length > 0) {
      return;
    }

    this.subscriptions.push(
      this.swUpdate.versionUpdates
        .pipe(
          filter(
            (evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY',
          ),
        )
        .subscribe(() => this.applyUpdate()),
      this.swUpdate.unrecoverable.subscribe(() => {
        document.location.reload();
      }),
      interval(UPDATE_CHECK_INTERVAL_MS).subscribe(() => this.requestUpdateCheck()),
      fromEvent(document, 'visibilitychange')
        .pipe(filter(() => document.visibilityState === 'visible'))
        .subscribe(() => this.requestUpdateCheck()),
    );

    this.requestUpdateCheck();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  private requestUpdateCheck() {
    this.swUpdate.checkForUpdate().catch(() => undefined);
  }

  private applyUpdate() {
    if (this.updating) {
      return;
    }
    this.updating = true;
    this.swUpdate
      .activateUpdate()
      .then(() => document.location.reload())
      .catch(() => document.location.reload());
  }
}
